import React, { useState, useMemo, Suspense, useEffect } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import { thirdPartyConfigTabs } from "./ThirdPartyConfig.constants";
// import PaymentConfigForm from "./PaymentConfigForm";
import { 
  yourbulksmsValidationSchema, 
  esendexValidationSchema
} from "src/util/validationSchemas";
import { 
  yourbulksmsInitialValues,
  esendexInitialValues, 
  SMS_PROVIDERS 
} from "./ThirdPartyConfig.constants";
import {
  Card,
  Button,
  Stack,
  Divider,
  Box,
} from '@mui/material';
import { useFormik, FormikProvider, Form } from 'formik';
import { LoadingButton } from '@mui/lab';
import { Loader } from "../Loader";
import {  
  thirdPartySmsConfig 
} from "src/react-query/endPoints";
import { useMutate, useGetDetail } from "src/hooks/useFetch.hook";
import { useSelectedTeam } from "../../hooks/useSelectedTeam";
import { useList } from "src/hooks/useFetch.hook";
import { useAccess } from "src/hooks/useAccess.hook";
import { FEATURE } from "src/util/enums";

const YourBulkSms = React.lazy(() => import("./YourBulkSms"))
const SmsTemplateForm = React.lazy(() => import("./SmsTemplateForm"));
const EsendexSms = React.lazy(() => import("./esendexSms"));

const ThirdPartyConfig = () => {
    const [selectedTab, setSelectedTab] = useState("sms config");
    const { data: smsGatewayList } = useList("getSmsGateway");
    const { teamId: parentCompanyId, teamType } = useSelectedTeam();
    const user = useSelectedTeam();
  const isReadOnly = useAccess(FEATURE.THIRD_PARTY, "R");
    const { mutate: yourBulkMutate, isLoading: yourBulkIsLoading } = useMutate("thirdPartySMS");
    const { mutate: esendexMutate, isLoading: esendexIsLoading } = useMutate("thirdPartySMS");
    const { data: smsConfig, isFetching } = useGetDetail("thirdPartySMS", {
      id: parentCompanyId,
    });
    const [isEsendexPresent, setIsEsendexPresent] = useState(false);
    const [isYourBulkSmsPresent, setIsYourBulkSmsPresent] = useState(false);

    const companySmsGateway = smsGatewayList && smsGatewayList?.find(
      (item) => item.id === user.smsGatewayId
    );

    const role = "root"; // This should be dynamically set based on the user's role
    const conditionalTabs = role !== "root" ? 
    thirdPartyConfigTabs.filter(i => i.value === 'payment config') : 
    thirdPartyConfigTabs;

  // const companyType = useMemo(() => {
  //   return user?.company?.companyType;
  // }, [user]);

    //const { data: paymentGateway = [] } = useList("availablePaymentGatewayListByCompany", company?.id);

    const paymentGateways = [
      { label: "Razorpay", formKey: "razorpay" },
      { label: "Stripe", formKey: "stripe" },
    ];

    const onPaymentGatewaySubmit = async (values) => {

      for (const key in values) {
        const config = values[key];

        // Detect if this is a new or existing record (e.g., check ID or config presence)
       // const existing = paymentGateway?.[key];

        // if (existing) {
        //   //await updatePaymentConfig(key, config);
        // } else {
        //   //await createPaymentConfig(key, config);
        // }
      }
    }

    const getInitialValues = (gateways, apiData) => {
      return gateways.reduce((acc, gateway) => {
        const key = gateway.formKey;
        acc[key] = {
          is_active: apiData?.[key]?.is_active || false,
          public_key: apiData?.[key]?.public_key || "",
          secret_key: apiData?.[key]?.secret_key || "",
          webhook_key: apiData?.[key]?.webhook_key || "",
          merchant_id: apiData?.[key]?.merchant_id || "",
          config_json: apiData?.[key]?.config_json || {},
        };
        return acc;
      }, {});
    };


    const paymentConfigFormik = useFormik({
    initialValues: getInitialValues(paymentGateways),
    onSubmit: onPaymentGatewaySubmit,
  });

    const handleTabChange = (e, tab) => {
        setSelectedTab(tab);
    };


    const visibleGateways = role !== "root" ? [paymentGateways[0]] : paymentGateways;

    const yourbulksmsSubmit = async (yourBulkSmsValues, { setSubmitting }) => {
        if (isReadOnly) {
          setSubmitting(false);
          return;
        }
        const mutateObject = {
          method: isYourBulkSmsPresent ? "PUT" : "POST",
          url: thirdPartySmsConfig(parentCompanyId),
        };

        yourBulkMutate(
        {
          url: mutateObject.url,
          method: mutateObject.method,
          body: { smsConfig: yourBulkSmsValues },
        },
        { onSuccess }
        );
      setSubmitting(false);
    }

    const onSuccess = () => {
        window.location.reload();
    }

    const yourBulkSmsFormik = useFormik({
        initialValues: yourbulksmsInitialValues,
        validationSchema: yourbulksmsValidationSchema,
        onSubmit: yourbulksmsSubmit,
    });

    const { 
      errors: yourBulkSmsErrors,
      touched: yourBulkSmsTouched,
      values: yourBulkSmsValues,
      handleChange: yourBulkSmsHandleChange,
      handleSubmit: yourBulkSmsHandleSubmit,
      isSubmitting: yourBulkSmsIsSubmitting,
      getFieldProps: yourBulkSmsGetFieldProps,
      resetForm: yourBulkSmsResetForm,
      setFieldValue: yourBulkSmsSetFieldValue,
      setErrors: yourBulkSmsSetErrors,
    } = yourBulkSmsFormik;

    const esendexSubmit = async (esendexValues, { setSubmitting }) => {
      if (isReadOnly) {
        setSubmitting(false);
        return;
      }
      const mutateObject = {
          method: isEsendexPresent ? "PUT" : "POST",
          url: thirdPartySmsConfig(parentCompanyId),
        };

        esendexMutate(
        {
          url: mutateObject.url,
          method: mutateObject.method,
          body: { smsConfig: esendexValues },
        },
        { onSuccess }
        );
      setSubmitting(false);
    };

    const esendexFormik = useFormik({
      initialValues: esendexInitialValues,
      validationSchema: esendexValidationSchema,
      onSubmit: esendexSubmit,
    });

    const {
      errors: esendexErrors,
      touched: esendexTouched,
      values: esendexValues,
      handleChange: esendexHandleChange,
      handleSubmit: esendexHandleSubmit,
      isSubmitting: esendexIsSubmitting,
      getFieldProps: esendexGetFieldProps,
      resetForm: esendexResetForm,
      setFieldValue: esendexSetFieldValue,
      setErrors: esendexSetErrors,
    } = esendexFormik;



    useEffect(() => {
      if (smsConfig) {
        const findyourBulkData = smsConfig.find(
          (item) => item.provider_name === SMS_PROVIDERS.YOUR_BULK_SMS
        );
        const findesendexData = smsConfig.find(
          (item) => item.provider_name === SMS_PROVIDERS.ESENDEX
        );
        if(findyourBulkData) {
          setIsYourBulkSmsPresent(true);
          yourBulkSmsResetForm({
            values: {
              ...yourbulksmsInitialValues,
              ...findyourBulkData,
              is_active: findyourBulkData.is_active === 1 ? true : false,
            },
          });
        } 
        if(findesendexData) {
          setIsEsendexPresent(true);
          esendexResetForm({
            values: {
              ...esendexInitialValues,
              ...findesendexData,
              is_active: findesendexData.is_active === 1 ? true : false,
            },
          });
        }
      }
    }, [smsConfig, yourBulkSmsResetForm, esendexResetForm]);

    return (
        <>
            <TabContext sx={{mt:5}} value={selectedTab}>
                <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
                  <RootTabStyle
                    indicatorColor="transparent"
                    centered
                    length={conditionalTabs.length}
                    onChange={handleTabChange}
                  >
                    {conditionalTabs && conditionalTabs.map((tab) => (
                      <RootTabItemStyles
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                      />
                    ))}
                  </RootTabStyle>
                </Stack>
                <Card sx={{ p :2 }}>
                  <TabPanel value="payment config">
                      {/* {paymentGateway.map((pg) => (
                        <PaymentConfigForm
                          key={pg.formKey}
                          values={formik.values[pg.formKey]}
                          touched={formik.touched[pg.formKey] || {}}
                          errors={formik.errors[pg.formKey] || {}}
                          setFieldValue={(name, value) =>
                            formik.setFieldValue(`${pg.formKey}.${name}`, value)
                          }
                          getFieldProps={(name) => formik.getFieldProps(`${pg.formKey}.${name}`)}
                          paymentGatewayName={pg}
                        />
                      ))}
                    <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }}>
                      <Button variant="contained" onClick={formik.handleSubmit}>
                        Save Configuration
                      </Button>
                    </Stack> */}
                  </TabPanel>
                  <TabPanel value="sms config">
                      <Card sx={{ p: 2 }}>
                        {(teamType === "GP" || (teamType !== "GP"  && companySmsGateway?.name === SMS_PROVIDERS.YOUR_BULK_SMS)) && (
                          <Box>
                            <FormikProvider value={yourBulkSmsFormik}>
                              <Form 
                                autoComplete="off" 
                                noValidate 
                                onSubmit={yourBulkSmsHandleSubmit}
                              >
                                <Suspense fallback={<Loader />}>
                                  <YourBulkSms
                                    values={yourBulkSmsValues}
                                    errors={yourBulkSmsErrors}
                                    touched={yourBulkSmsTouched}
                                    handleChange={yourBulkSmsHandleChange}
                                    getFieldProps={yourBulkSmsGetFieldProps}
                                    setFieldValue={yourBulkSmsSetFieldValue}
                                    setErrors={yourBulkSmsSetErrors}
                                  />
                                    {!isReadOnly && (
                                      <Stack direction="row" spacing={2} sx={{ mt: 2, justifyContent: "flex-end" }}>
                                        <LoadingButton
                                          size="large"
                                          type="submit"
                                          variant="contained"
                                          loading={yourBulkSmsIsSubmitting || yourBulkIsLoading}
                                        >
                                          Save
                                        </LoadingButton>
                                      </Stack>
                                    )}
                                </Suspense>
                              </Form>
                            </FormikProvider>
                          </Box>
                        )}
                          {(teamType === "GP" || (teamType !== "GP" && companySmsGateway?.name === SMS_PROVIDERS.ESENDEX)) && (
                          <>
                           {teamType === "GP" && <Divider sx={{pt: 3}}/>}
                            <Box>
                              <FormikProvider value={yourBulkSmsFormik}>
                                <Form 
                                  autoComplete="off" 
                                  noValidate 
                                  onSubmit={esendexHandleSubmit}
                                >
                                  <Suspense fallback={<Loader />}>
                                    <EsendexSms
                                      values={esendexValues}
                                      errors={esendexErrors}
                                      touched={esendexTouched}
                                      handleChange={esendexHandleChange}
                                      getFieldProps={esendexGetFieldProps}
                                      setFieldValue={esendexSetFieldValue}
                                      setErrors={esendexSetErrors}
                                    />
                                      {!isReadOnly && (
                                        <Stack direction="row" spacing={2} sx={{ mt: 2, justifyContent: "flex-end" }}>
                                          <LoadingButton
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={esendexIsSubmitting || esendexIsLoading}
                                          >
                                            Save
                                          </LoadingButton>
                                        </Stack>
                                      )}
                                  </Suspense>
                                </Form>
                              </FormikProvider>
                            </Box>
                          </>
                          )}
                      </Card>
                  </TabPanel>
                  <TabPanel value="sms templates">
                      <Suspense fallback={<Loader />}>
                        <SmsTemplateForm />
                      </Suspense>
                  </TabPanel>
                  <TabPanel value="mail config">
                      <div>SMS Config Content</div>
                  </TabPanel>
                  <TabPanel value="Recaptcha">
                      <div>Recaptcha Config Content</div>
                  </TabPanel>
                  <TabPanel value="google map apis">
                      <div>Google Map APIs Config Content</div>
                  </TabPanel>
                </Card>
            </TabContext>
        </>
    )
}

export default ThirdPartyConfig;